import { render, staticRenderFns } from "./VistaVisualizacionProductos.vue?vue&type=template&id=c1a177fc"
import script from "./VistaVisualizacionProductos.vue?vue&type=script&lang=js"
export * from "./VistaVisualizacionProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports